import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { FC } from 'react';
import { AnalyticsKeys } from 'types/analytics';

interface IWidgetEmptyStateProps {
	analyticsKey: AnalyticsKeys;
}

const WidgetEmptyState: FC<IWidgetEmptyStateProps> = ({ analyticsKey }) => (
	<Box
		display="flex"
		flexGrow={1}
		flexDirection="column"
		justifyContent="center"
		alignItems="center"
		p={2}
	>
		<Typography color="text.secondary">
			{intl.tr(`analytics.${analyticsKey}.empty`)}
		</Typography>
	</Box>
);

export default WidgetEmptyState;
